import React from 'react';
import MapContext from '../context';

import PropTypes from 'prop-types';
//import { selectionTypes } from '../../models/mapConfigConstants';

import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import List from '@mui/material/List';

import '../styles/CategoryGroupLayerPicker.css'






const GroupRenderer = ({ category, group, layerRenderer, keyVal, renderHidden}) => {

  const [, updateGroupState] = React.useState(category?.expanded !== undefined ? category.expanded : false);

  const layers = group.layers.filter(lyr => !lyr?.config?.hidden || renderHidden ).map(lyr => {
    let layerRenderParam = {
      keyVal: lyr.key,
      layer: lyr,
      category: category,
      updateGroup: (cul) => {
        updateGroupState(Math.random());
      }
    };
    return layerRenderer(layerRenderParam);
  });



  return (
    <div className="group" key={keyVal}>
      <div className="group-name">{group.name}</div>
      <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
        {layers}
      </List>
    </div>
  )
}

GroupRenderer.propTypes = {
  category: PropTypes.object,
  group: PropTypes.object,
  layerRenderer: PropTypes.func,
  keyVal: PropTypes.any,
  renderHidden: PropTypes.bool,
}


const CategoryRenderer = ({ category, layerRenderer, renderHidden }) => {
  const [, setCategoryExpanded] = React.useState(category?.expanded !== undefined ? category.expanded : false);
  const handleExpand = (event, expanded) => {
    category.expanded = expanded;
    setCategoryExpanded(expanded);
  };

  if (category.groups && category.groups.length > 0) {
    const groups = category.groups.map(grp => <GroupRenderer key={grp?.key} group={grp} category={category} layerRenderer={layerRenderer} renderHidden={renderHidden} />);

    return (
      <div className="category">
        <Accordion expanded={category.expanded !== undefined ? category.expanded === true : false} onChange={handleExpand}>

          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={`panel${category?.key}-content`}
            id={`panel${category?.key}-header`}
            className="category-name"
            sx={{
              backgroundColor: "primary.main",
              color: "primary.contrastText",
              '& .MuiAccordionSummary-expandIconWrapper .MuiSvgIcon-root': { color: 'primary.contrastText' } // use summary hover icon color
            }}
          >
            <Typography>{category?.name || 'Missing Category'}</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            {groups}
          </AccordionDetails>

        </Accordion>
      </div>
    );
  } else {
    return (<p>No Groups!</p>);
  }
}

CategoryRenderer.propTypes = {
  category: PropTypes.object,
  layerRenderer: PropTypes.func,
  renderHidden: PropTypes.bool,
}


const CategoriesRenderer = ({ categories, layerRenderer, renderHidden }) => {

  const rendered = categories.filter(a => !a.config?.hidden || renderHidden).map(category => <CategoryRenderer key={category?.key} category={category} layerRenderer={layerRenderer} renderHidden={renderHidden} />);

  return (
    <div className="categoriesContainer">
      {rendered}
    </div>
  )

}

CategoryRenderer.propTypes = {
  categories: PropTypes.array,
  layerRenderer: PropTypes.func,
  renderHidden: PropTypes.bool,
}


const CategoryGroupLayerRenderer = ({ categories, LayerRenderer, renderHidden }) => {
  const map = React.useContext(MapContext);


  if (map && categories)
    return (<CategoriesRenderer categories={categories} layerRenderer={LayerRenderer} renderHidden={renderHidden} />);
  else
    return (<div>Loading...</div>);
}

CategoryGroupLayerRenderer.propTypes = {
  categories: PropTypes.array,
  LayerRenderer: PropTypes.func,
  renderHidden: PropTypes.bool,
}


export default CategoryGroupLayerRenderer;